// @flow
import { Outlet } from 'react-router';

const General = (): React$Node => {
  return <Outlet />;
};

export default General;
